import Vue from 'vue'
import router from './../../router';

import {achost, DEFAULT_HEADERS, portal_name} from '../constants';

import vueAuth from '@/plugins/auth.js';

const APPROVED_POLICIES_KEY = 'acp.approved_policies';

// Only the login response carries approved_policies, so cache it to survive a reload.
function loadApprovedPolicies() {
    try {
        const stored = JSON.parse(localStorage.getItem(APPROVED_POLICIES_KEY));
        return Array.isArray(stored) ? stored : [];
    } catch (e) {
        return [];
    }
}

const state = () => ({
    isAuthenticated: vueAuth.isAuthenticated(),
    approvedPolicies: loadApprovedPolicies()
});

const actions = {
    logout(context) {
        vueAuth.logout().then(function() {
            context.commit('setAuthenticated', vueAuth.isAuthenticated())
            context.commit('setApprovedPolicies', []);
            return;
        })
    },

    //https://apex-connect.avalanchestudios.com/portal/${portal_name}/login
    //${achost}/portal/${portal_name}/login
    login({dispatch, commit}, payload) {
        return vueAuth.login({email:payload.email, password:payload.password}, {
            credentials: "same-origin",
            url: `${achost}/portal/${portal_name}/login`,
            headers: DEFAULT_HEADERS,
        })
        .then((response) => {
            commit('setAuthenticated', vueAuth.isAuthenticated());
            commit('setApprovedPolicies', response.data.approved_policies || []);

            const from = router.currentRoute.query['from'] || '/settings';
            router.replace(from)

            return dispatch("account/getGames", null, {root:true}).then(function(games) {
                var divisons = {};
                for (var i = 0; i < games.length; i++) {
                    switch(games[i].project) {
                        case "thp":
                            divisons["ew"] = 1
                            break;
                        case "shoebill":
                        case "cataclysm":
                            divisons["sr"] = 1
                    }
                }

                return response;
            });
        })
    },
    register(context, payload) {
        const policies = payload.policies;
        return vueAuth.register(payload.info, {
            url: `${achost}/api/v2/account`,
            headers: DEFAULT_HEADERS
        })
        .then(() => {
            return vueAuth.register(payload.info, {
                url: `${achost}/api/v1/acp/portal/user`,
                headers: DEFAULT_HEADERS
            })
        })
        .then((response) => {
            context.commit('setAuthenticated', vueAuth.isAuthenticated());
            
            context.commit('setApprovedPolicies', (policies || []).map(policy => ({
                policy_identifier: policy.identifier,
                policy_version_id: policy.version
            })));

            const from = router.currentRoute.query['from'] || '/settings';
            router.replace(from)
            return response;
        })
    },
    forgotPassword(context, payload) {
        return Vue.axios.post(`${achost}/api/v1/account/forgot_password`, {
            email: payload.email
        }, {
            headers: DEFAULT_HEADERS
        })
    },
    resetPassword(context, payload) {
        return Vue.axios.post(`${achost}/api/v1/account/reset_password`, {
            token: payload.token,
            password: payload.password
        }, {
            headers: DEFAULT_HEADERS
        })
    },
    createVerificationToken(context, payload) {
        return Vue.axios.post(`${achost}/api/v2/account/verify_email`, {email: payload.email}, {
            headers: DEFAULT_HEADERS
        })
    },
    verifyEmail(context, payload) {
        return Vue.axios.post(`${achost}/api/v1/account/verify_email`, {token:payload.token}, {
            headers: DEFAULT_HEADERS
        })
    },

    async changePassword(context, payload) {
        await Vue.axios.post(`${achost}/api/v1/account/change_password`, {
            current_password: payload.oldPassword,
            new_password: payload.newPassword
        }, {
            headers: DEFAULT_HEADERS
        });
        return context.dispatch('logout');
    },
    changeEmail(context, payload) {
        return Vue.axios.post(`${achost}/api/v1/account/change_email`, {
            email: payload.email,
            password: payload.password
        }, {
            headers: DEFAULT_HEADERS
        }).then(function() {
            return context.dispatch('logout');
        });
    },
    deleteAccount(context, payload) {
        return Vue.axios.post(`${achost}/api/v1/account/delete`, {
            password: payload.password
        }, {
            headers: DEFAULT_HEADERS
        }).then(function() {
            return context.dispatch('logout');
        })
    },
    restoreAccount(context, payload) {
        return Vue.axios.post(`${achost}/api/v1/account/restore`, {
            email: payload.email,
            password: payload.password,
        }, {
            headers: DEFAULT_HEADERS
        }).then(function() {

        })
    }
};

const mutations = {
    setAuthenticated(state, isAuthenticated) {
       state.isAuthenticated = isAuthenticated;
    },
    setApprovedPolicies(state, policies) {
       state.approvedPolicies = Array.isArray(policies) ? policies : [];
       try {
           localStorage.setItem(APPROVED_POLICIES_KEY, JSON.stringify(state.approvedPolicies));
       } catch (e) { /* storage unavailable; in-memory state still applies */ }
    },
};

export const auth = {
    namespaced: true,
    actions,
    mutations,
    state
}